import { useEffect } from 'react';
import { RequestState } from '../../@types/RequestState';
import { CMS, Cars, Facet, SearchIndex } from './SearchModels';
import { decode } from './Utils/url';
import useMultiSearch from './useMultiSearch';
import useVehicle from './useVehicle';

export type SearchType = 'cars' | 'retailers_cms';

interface SearchResult {
  carFacets?: Facet[];
  cars?: SearchIndex<Cars>;
  retailers_cms?: SearchIndex<CMS>;
}

interface SearchSettings {
  multiSearchUrl: string;
  vehicleSearchUrl: string;
  contentSearchUrl: string;
}

const useSearch = (
  urlSearchParams: URLSearchParams,
  settings: SearchSettings,
  tab: SearchType,
  disabled?: boolean
): [SearchResult | undefined, RequestState, ((searchType?: SearchType) => void) | undefined] => {
  const query = urlSearchParams.get('query') || undefined;
  const qf = urlSearchParams.get('qf');

  const [multiSearch, requestMutli, onLoadMore] = useMultiSearch(
    settings.multiSearchUrl,
    settings.vehicleSearchUrl,
    settings.contentSearchUrl,
    !qf ? query : undefined,
    disabled
  );

  const [initialVehicle] = useVehicle(settings.vehicleSearchUrl, 'hits=0');

  const [vehicle, requestCars, onLoadMoreCars, setCars] = useVehicle(
    settings.vehicleSearchUrl,
    qf ? decode(qf) : query ? undefined : '',
    disabled
  );

  useEffect(() => {
    if (multiSearch?.vehicle && query) {
      setCars(multiSearch.vehicle);
    }
  }, [multiSearch]);

  const result: [SearchResult | undefined, RequestState, (() => void) | undefined] =
    qf || !query
      ? [
          vehicle
            ? {
                carFacets: initialVehicle?.facets || undefined,
                cars: vehicle,
              }
            : undefined,
          requestCars,
          onLoadMoreCars,
        ]
      : [
          multiSearch
            ? {
                carFacets: initialVehicle?.facets || undefined,
                cars: multiSearch?.vehicle,
                retailers_cms: multiSearch?.retailer_cms,
              }
            : undefined,
          requestMutli,
          tab === 'retailers_cms'
            ? multiSearch?.retailer_cms.documentList.pagination.nextPage?.query
              ? onLoadMore
              : undefined
            : multiSearch?.vehicle.documentList.pagination.nextPage?.query
              ? onLoadMore
              : undefined,
        ];
  return result;
};

export default useSearch;
